module.exports = __webpack_public_path__ + "img/commentLi.23d24a2a.svg";